import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { DeepNullable } from 'ts-essentials';
import { MarketTypes } from '../types';

export type PBuildingItemType = {
  house: string;
  id: number;
};

export type APIApartmentFilterLimitsRes = {
  buildings: DeepNullable<
    {
      streetName: number;
      buildings: PBuildingItemType[];
    }[]
  >;
};

export const useBuildingList = (query?: string, fetch = true) => {
  const { data, error, isLoading } = useSWR(fetch ? [query] : null, () =>
    !!query
      ? fetcher
          .swr<APIApartmentFilterLimitsRes>('/building/search-by-street', {
            method: 'post',
            data: { streetName: query, marketType: MarketTypes.SECONDARY },
          })
          .then((res) => res)
      : null,
  );

  return { buildings: data?.buildings.length ? data?.buildings : [], error, isLoading };
};

export default useBuildingList;
